import * as React from 'react';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import { Box } from '@mui/material';
import { TableDataRow, TableSkeletonRows, TableEmptyRow } from './TableBodyContent';

/**
 * Компонент для відображення згрупованих даних прайс-листа
 */
export const GroupedPriceListBody = ({
    groupedData,
    columns,
    isShowCategory,
    isShowBrand,
    isPointCursor,
    setClickRow,
    cellBtnActionByType,
    l,
    handleClickOpenImage,
    language,
}) => {
    return (
        <>
            {Object.keys(groupedData).map((category, i) => {
                const brand = groupedData[category];

                return (
                    <React.Fragment key={category + i}>
                        {isShowCategory && (
                            <TableRow>
                                <TableCell colSpan={columns.length} sx={{ padding: 1 }}>
                                    <Box>
                                        <Typography color="GrayText" variant="h6">
                                            {category}
                                        </Typography>
                                    </Box>
                                </TableCell>
                            </TableRow>
                        )}

                        {Object.keys(brand).map((brandName, j) => {
                            const data = brand[brandName];

                            return (
                                <React.Fragment key={brandName + j}>
                                    {isShowBrand && (
                                        <TableRow>
                                            <TableCell></TableCell>
                                            <TableCell colSpan={columns.length - 1} sx={{ padding: 1 }}>
                                                <Box>
                                                    <Typography
                                                        fontWeight="bold"
                                                        fontStyle="italic"
                                                        variant="h6"
                                                    >
                                                        {brandName}
                                                    </Typography>
                                                </Box>
                                            </TableCell>
                                        </TableRow>
                                    )}

                                    {data.map((row, index) => (
                                        <TableDataRow
                                            key={row.id || index}
                                            row={row}
                                            index={index}
                                            columns={columns}
                                            isPointCursor={isPointCursor}
                                            setClickRow={setClickRow}
                                            cellBtnActionByType={cellBtnActionByType}
                                            l={l}
                                            handleClickOpenImage={handleClickOpenImage}
                                            language={language}
                                        />
                                    ))}
                                </React.Fragment>
                            );
                        })}
                    </React.Fragment>
                );
            })}
        </>
    );
};

/**
 * Компонент для відображення незгрупованих даних прайс-листа
 */
export const UngroupedPriceListBody = ({
    rows,
    columns,
    isPointCursor,
    setClickRow,
    cellBtnActionByType,
    l,
    handleClickOpenImage,
    language,
}) => {
    return (
        <>
            {rows.map((row, index) => (
                <TableDataRow
                    key={row.id || index}
                    row={row}
                    index={index}
                    columns={columns}
                    isPointCursor={isPointCursor}
                    setClickRow={setClickRow}
                    cellBtnActionByType={cellBtnActionByType}
                    l={l}
                    handleClickOpenImage={handleClickOpenImage}
                    language={language}
                />
            ))}
        </>
    );
};

/**
 * Головний компонент для відображення тіла таблиці прайс-листа
 */
export const PriceListTableBody = ({
    rows,
    columns,
    groupedData,
    isGrouped,
    isShowCategory,
    isShowBrand,
    isPointCursor,
    setClickRow,
    cellBtnActionByType,
    l,
    handleClickOpenImage,
    language,
    tableEmptyText,
}) => {
    // rows ще завантажуються
    if (rows === undefined || rows === null) {
        return <TableSkeletonRows columns={columns} />;
    }

    // rows завантажилися, але порожні
    if (rows.length === 0) {
        return <TableEmptyRow columns={columns} tableEmptyText={tableEmptyText} />;
    }

    // є дані для відображення
    if (isGrouped) {
        return (
            <GroupedPriceListBody
                groupedData={groupedData}
                columns={columns}
                isShowCategory={isShowCategory}
                isShowBrand={isShowBrand}
                isPointCursor={isPointCursor}
                setClickRow={setClickRow}
                cellBtnActionByType={cellBtnActionByType}
                l={l}
                handleClickOpenImage={handleClickOpenImage}
                language={language}
            />
        );
    }

    return (
        <UngroupedPriceListBody
            rows={rows}
            columns={columns}
            isPointCursor={isPointCursor}
            setClickRow={setClickRow}
            cellBtnActionByType={cellBtnActionByType}
            l={l}
            handleClickOpenImage={handleClickOpenImage}
            language={language}
        />
    );
};

export default PriceListTableBody;
